import api from 'networkapp-api-connector';

let pending = [];

export default {
    fetch() {
        return api.notifications.fetch().then(data => {
            app.store.dispatch(app.actions.notifications.received(data.notifications));
            return data;
        });
    },
    markRead: id => {
        if (pending[id]) return pending[id];

        console.log('Mark as read: ', id);
        app.store.dispatch(app.actions.notifications.markRead(id));

        pending[id] = api.notifications
            .markRead(id)
            .then(data => {
                app.store.dispatch(app.actions.notifications.received([data]));
                delete pending[id];
            })
            .catch(err => {
                delete pending[id];
                console.error(err);
            });

        return pending[id];
    },
};
